import axios from 'axios';
import Vue from 'vue';
import store from '@/store';

const api = axios.create({
  baseURL: process.env.VUE_APP_API_URL,
  headers: {
    Accept: 'application/json',
  },
});

Vue.prototype.$api = api;

const maintenancePath = `${process.env.BASE_URL || '/'}maintenance`
  .replace(/\/{2,}/g, '/')
  .replace(/\/$/, '') || '/maintenance';

api.interceptors.response.use(
  (response) => {
    console.debug(`HTTP < ${response.status}`);

    if (response.status !== 503 && store.getters['maintenance/isEnabled']) {
      store.dispatch('maintenance/disable');
    }

    return Promise.resolve(response);
  },
  (error) => {
    const status = error.response ? error.response.status : null;
    if (status) {
      console.debug(`HTTP < ${status}`);

      if (status === 503) {
        store.dispatch('maintenance/enable');
        if (window.location.pathname !== maintenancePath) {
          window.location.assign(maintenancePath);
        }
      }
    } else {
      console.debug('HTTP < No response');
      console.error(error);
    }

    if (status !== 503) {
      Vue.prototype.$rollbar.error(error);
    }

    return Promise.reject(error);
  },
);

api.interceptors.response.use(
  (response) => response,
  async (error) => {
    const status = error.response?.status;
    const original = error.config;
    const isImpersonating = store.getters['auth/isImpersonating'];

    if (
      isImpersonating
      && (status === 401 || status === 403)
      && original
      && !original._impersonationRetry
      && !original.url?.includes('/impersonation/refresh')
    ) {
      original._impersonationRetry = true;
      try {
        await store.dispatch('auth/refreshImpersonationTokens');
        const token = store.getters['auth/tokens']?.token;
        if (token) {
          original.headers = original.headers || {};
          original.headers.Authorization = `Bearer ${token}`;
        }
        return api.request(original);
      } catch (refreshError) {
        return Promise.reject(error);
      }
    }

    return Promise.reject(error);
  },
);

export default api;
